import createCachedSelector from 're-reselect';

export default (namespace, path, createVisibleStakeTypeGroupIdsSelector) => {
  /**
   * @private
   *
   * Get main-line `stakeIdsTree` the following structure
   *
   * > [matchId][lineId][stakeTypeGroupId] = stakeTypeId
   *
   * @param {object} state
   * @return {Immutable.Map<number, Immutable.Map<number, Immutable.Map<number, number>>>}
   */
  const mainLineStakesGrid = (state) => {
    return state[namespace].getIn([...path, 'mainLineStakesGrid']);
  };
  /**
   * Create the "stake ids list" selector that is built depending on the given `lineId` and `matchId`.
   *
   *
   * The resulting list may contain `null` entries when there is no any `stakeId` for a `stakeTypeGroupId`.
   *
   * @param {number} lineId
   * @param {number} matchId
   * @return {function(state:object):Immutable.List<number|null>}
   */
  return createCachedSelector(
    (state, lineId, matchId) => createVisibleStakeTypeGroupIdsSelector({ matchId })(state),
    (state, lineId, matchId) => mainLineStakesGrid(state).getIn([matchId, lineId], null),
    /**
     * @param {Immutable.List<number>} visibleGroupIds
     * @param {Immutable.Map<number, number>|null} stakeIdByGroupId
     */
    (visibleGroupIds, stakeIdByGroupId) => {
      return visibleGroupIds.map((groupId) => {
        return (stakeIdByGroupId && stakeIdByGroupId.get(groupId)) || null;
      });
    },
  )((state, lineId, matchId) => `${matchId}.${lineId}`);
};
